module.exports = __webpack_public_path__ + "img/blurmap-VARILUX-X-SERIES_full_white.3e24b060.png";